import {Button} from 'platform/components';

import {useDispatch} from 'react-redux';

import {useInspectionToInProgressMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import {updateAuditState} from '../../store/carAudit/reducer';
import {LoadAuditDataResponseItemBody} from '../../types/LoadAuditDataResponseItemBody';

interface ReopenInspectionProps {
  inspectionId: string;
  title?: string;
  onSuccess?: () => void;
}

export function ReopenInspection(props: ReopenInspectionProps & TestIdProps) {
  const [reopenInspection, reopenInspectionResponse] = useInspectionToInProgressMutation();
  const dispatch = useDispatch();

  const onInspectionReopen = () =>
    reopenInspection({inspectionId: props.inspectionId})
      .unwrap()
      .then(() => {
        dispatch(
          updateAuditState({
            state: LoadAuditDataResponseItemBody.state.IN_PROGRESS,
          })
        );
        props.onSuccess?.();
      })
      .catch(handleApiError);

  return (
    <Button
      data-testid={suffixTestId('inspectionHeader', props)}
      onClick={onInspectionReopen}
      isLoading={reopenInspectionResponse.isLoading}
      isDisabled={reopenInspectionResponse.isLoading}
      title={props.title ?? i18n.t('general.actions.reopen')}
    />
  );
}
